import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { Database } from '../../server/database';
import { getAssetImage } from '../util/util';
import { Server } from '../../server/server';
import './Modal.css'
import './SelectAssetModal.css'

interface SelectAssetModalProps {
  open: boolean;
  onClose: Function;
}

interface SelectAssetModalState {
  category: string;
}

class SelectAssetModal extends React.Component<SelectAssetModalProps, SelectAssetModalState> {
  constructor(props:SelectAssetModalProps) {
    super(props);

    this.state = {
      category: 'all',
    }

    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onSelectAsset = this.onSelectAsset.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onCategoryChange(e: React.FormEvent<HTMLSelectElement>) {
    const element = e.target as HTMLSelectElement;
    this.setState({category: element.value});
  }

  onSelectAsset(e:any) {
    this.props.onClose(e.target.parentElement.id);
  }

  onClose() {
    this.props.onClose();
  }

  renderAssetPanel(asset:any, marginRight:number = 0) {
    let src = getAssetImage(asset);
    let mrs = marginRight.toString() + 'px';
    return (
      <div key={asset.id} id={asset.id} className="select-asset-modal-asset-panel" style={{marginRight: mrs}} onClick={this.onSelectAsset}>
        <img className="select-asset-modal-asset-image" src={src} />
        <div style={{width: '100%', textAlign: 'left'}}>{asset.name}</div>
        <div style={{marginRight: '10px'}}>x{asset.quantity.toString()}</div>
      </div>
    )
  }

  renderSelectMode() {
    let assets = Server.user.getAssetsByCategory(this.state.category);

    let sortedAssets = [];
    for(let i = 0; i < assets.length; i++) {
      let quantity = Server.user.getAssetQuantity(assets[i].id);
      if(Server.user.getBanner() == assets[i].id && quantity == 1)
        continue;
      if(Server.user.getPortrait() == assets[i].id && quantity == 1)
        continue;
      if(assets[i].type == 'currency' || assets[i].type == 'pack')
        continue;
      let asset = {...assets[i], ...Database.getAsset(assets[i].id)};
      sortedAssets.push(asset);
    }

    sortedAssets.sort((a, b)=>{
      if(a.quantity > b.quantity)
        return -1;
      else if(a.quantity < b.quantity)
        return 1;

      if(a.name < b.name)
        return -1;
      else if(a.name > b.name)
        return 1;

      return 0;
    })

    let panelMarginRight = sortedAssets.length >= 5 ? 10 : 0;

    let assetDivs = [];
    for(let i = 0; i < sortedAssets.length; i++) 
      assetDivs.push(this.renderAssetPanel(sortedAssets[i], panelMarginRight));

    return (
      <div>
        <select style={{width: '100%', marginBottom: '10px'}} value={this.state.category} onChange={this.onCategoryChange}>
          <option value="all">All</option>
          <option value="collectible">Collectible</option>
          <option value="consumable">Consumable</option>
          <option value="cosmetic">Cosmetic</option>
          <option value="currency">Currency</option>
          <option value="pack">Pack</option>
        </select>
        {assetDivs.length > 0 ?
          <div className="select-asset-modal-asset-container">
            {assetDivs}
          </div>
          :
          <div>No assets in this category.</div>
        }
      </div>
    )
  }

  render() {
    if(!this.props.open)
      return (null);

    return (
      <div className="modal open">
        <div className="modal-content select-asset-modal-content">
          <button className="modal-close-button" onClick={this.onClose}>
            <BsFillXCircleFill />
          </button>
          <div className="select-asset-modal-header">Inventory</div>
            {this.renderSelectMode()}
        </div>
      </div>
    );
  }
}

export default SelectAssetModal;